






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Spinner from '@/components/Spinner.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface User {
    username: string;
    oldUsername: string;
    displayName: string;
    role: string;
    password: string;
}

@Component({
  components: {
    Spinner,
    ConnectionErrorContent,
  },
})
export default class UserSettings extends Vue {
    private statusAll!: string;
    private usersList!: User[];
    private newUser!: User;

    private data() {
        return {
            statusAll: 'loading',
            usersList: [],
            newUser: {username: '', oldUsername: '', displayName: '', role: 'user', password: ''},
        };
    }

    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.loadData();
    }

    private loadData() {
        this.statusAll = 'loading';
        this.usersList = [];
        this.$http.get('settings/users/get/all').then((response: AxiosResponse) => {
            this.usersList = response.data;
            for (let i = 0; i < this.usersList.length; i++) {
                this.usersList[i].oldUsername = this.usersList[i].username;
            }
            this.statusAll = 'success';
        }).catch((error) => {
            this.statusAll = 'error';
        });
    }

    private createNewUser() {
        if (this.newUser.username !== '' && this.newUser.password !== '') {
            this.$http.post('settings/users/new', this.newUser).then((response: AxiosResponse) => {
                // this.statusList = 'success';
                this.newUser = {username: '', oldUsername: '', displayName: '', role: 'user', password: ''};
                this.loadData();
            }).catch((error) => {
                // this.statusList = 'error';
            });
        }
    }

    private updateUser(user: User) {
        this.$http.post('settings/users/update', user).then((response: AxiosResponse) => {
            // this.statusList = 'success';
            this.loadData();
        }).catch((error) => {
            // this.statusList = 'error';
        });
    }

    private deleteUser(oldUsername: string) {
        this.$http.post('settings/users/delete/' + oldUsername).then((response: AxiosResponse) => {
            // this.statusList = 'success';
            this.loadData();
        }).catch((error) => {
            // this.statusList = 'error';
        });
    }
}
